/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminEbayEnvironment,
    AdminEbayEnvironmentFromJSON,
    AdminEbayEnvironmentFromJSONTyped,
    AdminEbayEnvironmentToJSON,
} from './AdminEbayEnvironment';
import {
    AdminEbayListingStatus,
    AdminEbayListingStatusFromJSON,
    AdminEbayListingStatusFromJSONTyped,
    AdminEbayListingStatusToJSON,
} from './AdminEbayListingStatus';
import {
    AdminEbayPriceHint,
    AdminEbayPriceHintFromJSON,
    AdminEbayPriceHintFromJSONTyped,
    AdminEbayPriceHintToJSON,
} from './AdminEbayPriceHint';

/**
 * 
 * @export
 * @interface AdminEbayListing
 */
export interface AdminEbayListing {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof AdminEbayListing
     */
    aspects: { [key: string]: Array<string>; };
    /**
     * 
     * @type {number}
     * @memberof AdminEbayListing
     */
    buyerShipping: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    condition?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    conditionDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    endedAt?: string;
    /**
     * 
     * @type {AdminEbayEnvironment}
     * @memberof AdminEbayListing
     */
    environment: AdminEbayEnvironment;
    /**
     * 
     * @type {number}
     * @memberof AdminEbayListing
     */
    imagesCount: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    lastError?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    listingId?: string;
    /**
     * ListingURL is the buyers' page once published.
     * @type {string}
     * @memberof AdminEbayListing
     */
    listingUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEbayListing
     */
    price?: number;
    /**
     * 
     * @type {AdminEbayPriceHint}
     * @memberof AdminEbayListing
     */
    priceHint: AdminEbayPriceHint;
    /**
     * Problems keep the listing from being published; empty when it is ready.
     * @type {Array<string>}
     * @memberof AdminEbayListing
     */
    problems: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    publishedAt?: string;
    /**
     * Saved is false for a draft filled from the product and not saved yet.
     * @type {boolean}
     * @memberof AdminEbayListing
     */
    saved: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    sku: string;
    /**
     * 
     * @type {AdminEbayListingStatus}
     * @memberof AdminEbayListing
     */
    status: AdminEbayListingStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbayListing
     */
    updatedByName?: string;
}



export function AdminEbayListingFromJSON(json: any): AdminEbayListing {
    return AdminEbayListingFromJSONTyped(json, false);
}

export function AdminEbayListingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbayListing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aspects': json['aspects'],
        'buyerShipping': json['buyerShipping'],
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'categoryName': !exists(json, 'categoryName') ? undefined : json['categoryName'],
        'condition': !exists(json, 'condition') ? undefined : json['condition'],
        'conditionDescription': !exists(json, 'conditionDescription') ? undefined : json['conditionDescription'],
        'description': json['description'],
        'endedAt': !exists(json, 'endedAt') ? undefined : json['endedAt'],
        'environment': AdminEbayEnvironmentFromJSON(json['environment']),
        'imagesCount': json['imagesCount'],
        'lastError': !exists(json, 'lastError') ? undefined : json['lastError'],
        'listingId': !exists(json, 'listingId') ? undefined : json['listingId'],
        'listingUrl': !exists(json, 'listingUrl') ? undefined : json['listingUrl'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'priceHint': AdminEbayPriceHintFromJSON(json['priceHint']),
        'problems': json['problems'],
        'publishedAt': !exists(json, 'publishedAt') ? undefined : json['publishedAt'],
        'saved': json['saved'],
        'sku': json['sku'],
        'status': AdminEbayListingStatusFromJSON(json['status']),
        'title': json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedByName': !exists(json, 'updatedByName') ? undefined : json['updatedByName'],
    };
}

export function AdminEbayListingToJSON(value?: AdminEbayListing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aspects': value.aspects,
        'buyerShipping': value.buyerShipping,
        'categoryId': value.categoryId,
        'categoryName': value.categoryName,
        'condition': value.condition,
        'conditionDescription': value.conditionDescription,
        'description': value.description,
        'endedAt': value.endedAt,
        'environment': AdminEbayEnvironmentToJSON(value.environment),
        'imagesCount': value.imagesCount,
        'lastError': value.lastError,
        'listingId': value.listingId,
        'listingUrl': value.listingUrl,
        'price': value.price,
        'priceHint': AdminEbayPriceHintToJSON(value.priceHint),
        'problems': value.problems,
        'publishedAt': value.publishedAt,
        'saved': value.saved,
        'sku': value.sku,
        'status': AdminEbayListingStatusToJSON(value.status),
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedByName': value.updatedByName,
    };
}

